// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/folder-minus.js';

import { paths } from '../generated/folder-minus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('folder-minus', Original, paths);
